module.exports = __webpack_public_path__ + "img/display-fill.e33716a3.svg";